import React, { createContext, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { TOKEN_POST } from "../API/userApi";

export const UserContext = createContext();

export const UserStorage = ({ children }) => {
  const [user, setUser] = useState(null);
  const [login, setLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const userLogout = useCallback(
    async function () {
      setUser(null);
      setError(null);
      setLoading(false);
      setLogin(null);
      window.localStorage.clear();
      navigate("/");
    },
    [navigate]
  );

  async function userLogin(email, password) {
    try {
      setError(null);
      setLoading(true);

      const { url, options } = TOKEN_POST({ email, password });

      const userResponse = await fetch(url, options);
      const userJson = await userResponse.json();

      if (!userResponse.ok) {
        if (userResponse.status === 401) {
          toast.error("Email/Senha incorretos.");

          return;
        }

        toast.error(
          "Houve um erro no Servidor, contate o suporte ou tente mais tarde."
        );

        return;
      }

      if (userJson.data.active === 0) {
        toast.error(
          "Esse Usuário está desativado, contate o suporte para ativa-lo ou tente com outro."
        );
        
      } else if (userJson.data.active == 1) {
        setUser(userJson.data);

        window.localStorage.setItem("token", userJson.data.token);
        window.localStorage.setItem("user", JSON.stringify(userJson.data));

        setLogin(true);
        navigate("/moderation");
      }
    } catch (err) {
      console.log(err);

      toast.error(
        "Houve um erro no Servidor, contate o suporte ou tente mais tarde."
      );
      setLogin(false);
    } finally {
      setLoading(false);
    }
  }

  return (
    <UserContext.Provider
      value={{
        userLogin,
        userLogout,
        loading,
        login,
        error,
        user,
        ToastContainer,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
